/**
 * TotalSalesStatus
 * --
 */
import { useState, useEffect } from 'react';
import { Content, Title, Row, Col } from 'components';
import { Button, Statistic, Spin } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import MessageAlert, { strCut, stringToMoneyFormat } from 'utils';
import moment from 'moment';
import { useUserStack } from 'store';
const MOMENT_FORMAT = 'YYYY-MM-DD';
const today = moment().format(MOMENT_FORMAT);

/**----------------------------------------
 * [Component] 홈 > 매장별 매출 차트
 * ----------------------------------------
 */
const TotalSalesStatus = ({
  loading,
  mallList,
  storeList,
  isMobile,
  permission,
  shopType,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  // console.log('[TotalSalesStatus] mallList: ', mallList);
  // console.log('[TotalSalesStatus] storeList: ', storeList);

  const mallData = mallList.filter(
    (item) => moment(item.date).format(MOMENT_FORMAT) === today,
  );
  const storeData = storeList.filter(
    (item) => moment(item.date).format(MOMENT_FORMAT) === today,
  );

  const totalAmountMall = mallData.reduce(
    (acc, cur) => (acc += Number(cur.totalAmount ?? 0)),
    0,
  );
  const netsAmountMall = mallData.reduce(
    (acc, cur) => (acc += Number(cur.netsAmount ?? 0)),
    0,
  );
  const totalAmountStore = storeData.reduce(
    (acc, cur) => (acc += Number(cur.totalAmount ?? 0)),
    0,
  );
  const netsAmountStore = storeData.reduce(
    (acc, cur) => (acc += Number(cur.netsAmount ?? 0)),
    0,
  );
  /* ===== RENDER ===== */
  // JSX: start
  return (
    <>
      <Spin spinning={loading}>
        <Content
          fullWidth
          padding={0}
          backgroundColor={'none'}
          width={'100%'}
          style={{
            marginBottom: 5,
            // display: 'flex',
            // justifyContent: 'space-between',
          }}
        >
          <Row>
            {[
              ...(shopType === null
                ? [
                    {
                      title: '전체 총매출',
                      value: stringToMoneyFormat(
                        Number(totalAmountMall ?? 0) +
                          Number(totalAmountStore ?? 0),
                      ),
                      suffix: '원',
                      // link: '/order/list?deposit_status=PENDING',
                    },
                    {
                      title: '전체 순매출',
                      value: stringToMoneyFormat(
                        Number(netsAmountMall ?? 0) +
                          Number(netsAmountStore ?? 0),
                      ),
                      suffix: '원',
                      // link: '/order/list?deposit_status=PENDING',
                    },
                  ]
                : []),

              // 쇼핑몰 매출만 집계
              ...(shopType !== 'STORE'
                ? [
                    {
                      title: '쇼핑몰 총매출',
                      value: stringToMoneyFormat(Number(totalAmountMall ?? 0)),
                      suffix: '원',
                      // link: '/shipping/list/PENDING',
                      link: '/order/dashboard',
                    },
                    {
                      title: '쇼핑몰 순매출',
                      value: stringToMoneyFormat(Number(netsAmountMall ?? 0)),
                      suffix: '원',
                      // link: '/shipping/list/PREPARING',
                      link: '/order/dashboard',
                    },
                  ]
                : []),

              // 쇼핑몰 매출만 집계
              ...(shopType !== 'SHOP'
                ? [
                    {
                      title: '매장 총매출',
                      value: stringToMoneyFormat(Number(totalAmountStore ?? 0)),
                      suffix: '원',
                      // link: '/shipping/list/ON_HOLD',
                      link: '/sales/dashboard/daily',
                    },
                    {
                      title: '매장 순매출',
                      value: stringToMoneyFormat(Number(netsAmountStore ?? 0)),
                      suffix: '원',
                      link: '/sales/dashboard/daily',
                      // link: '/shipping/list/SHIPPING',
                    },
                  ]
                : []),
            ].map((_item, _index) => (
              <Col
                key={`${_item.label}-${_index}`}
                // x={4}
                // xs={12}
                // sm={12}
                // md={8}
                // lg={8}
                // xl={4}
                // xxl={4}
                {...(shopType === null
                  ? {
                      sm: 12,
                      md: 8,
                      lg: 8,
                      xl: 4,
                      xxl: 4,
                    }
                  : { x: 12 })}
              >
                <div
                  className="boxShadow"
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `98.5%`,
                    height: `98%`,
                    margin: '0 2px',
                    padding: isMobile ? '6px 5px' : '16px 15px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Statistic
                    className="cursorOverOpacity"
                    direction={'row'}
                    size="large"
                    title={
                      <div
                        style={{
                          fontSize: isMobile ? 13 : 14,
                        }}
                      >
                        {_item.title}
                      </div>
                    }
                    value={_item.value}
                    suffix={_item.suffix}
                    // style={{ justifyContent: 'center' }}

                    valueStyle={{
                      fontSize: isMobile ? 12 : '1.45em',
                      // fontSize: '1.45em',
                      color:
                        _item.value === '0' || _item.value === 0
                          ? '#7f7f7f'
                          : '#1677ff',
                      // textDecoration: 'underline !important',
                    }}
                  />
                  {_index > 1 ? (
                    <div>
                      <Button
                        style={{
                          fontSize: isMobile ? 10 : 14,
                          minWidth: isMobile ? 25 : 32,
                        }}
                        shape="circle"
                        onClick={() => window.open(_item.link, '_blank')}
                      >
                        <ExportOutlined />
                      </Button>
                    </div>
                  ) : null}
                </div>
              </Col>
            ))}
          </Row>
        </Content>
      </Spin>
    </>
  ); // JSX: end
};

TotalSalesStatus.defaultProps = {
  mallList: null,
};
export default TotalSalesStatus;
